export const excludedEmojis = [
    "face with symbols on mouth",
    "smiling face with horns",
    "angry face with horns",
    "ogre",
    "goblin",
    "middle finger",
    "mage",
    "man mage",
    "woman mage",
    "vampire",
    "man vampire",
    "woman vampire",
    "kiss man, man",
    "couple with heart man, man",
    "couple with heart woman, woman",
    "family man, man, boy",
    "family man, man, girl",
    "family man, man, girl, boy",
    "family man, man, boy, boy",
    "family man, man, girl, girl",
    "family woman, woman, boy",
    "family woman, woman, girl",
    "family woman, woman, boy, girl",
    "family woman, woman, boy, boy",
    "family woman, woman, girl, girl",
    "person",
    "person blond hair",
    "person beard",
    "person frowning",
    "person frowning",
    "person pouting",
    "person gesturing NO",
    "person gesturing OK",
    "person tipping hand",
    "person raising hand",
    "person bowing",
    "person facepalming",
    "person shrugging",
    "police officer",
    "detective",
    "guard",
    "construction worker",
    "person wearing turban",
    "superhero",
    "supervillain",
    "merperson",
    "elf",
    "genie",
    "zombie",
    "person getting massage",
    "person getting haircut",
    "person walking",
    "eggplant",
    "peach",
    "crystal ball",
    "slot machine",
    "bikini",
    "Aries",
    "Taurus",
    "Gemini",
    "Cancer",
    "Leo",
    "Virgo",
    "Libra",
    "Scorpio",
    "Sagittarius",
    "Capricorn",
    "Aquarius",
    "Pisces",
    "rainbow flag",
    "bottle with popping cork",
    "wine glass",
    "cocktail glass",
    "tropical drink",
    "beer mug",
    "clinking beer mugs",
    "clinking glasses",
    "tumbler glass",
    "kiss woman, woman",
    "kiss man, man",
    "kiss",
    "couple with heart",
    "men holding hands",
    "women holding hands",
    "cigarette",
    "person in steamy room",
    "man in steamy room",
    "woman in steamy room",
    "people with bunny ears",
    "men with bunny ears",
    "women with bunny ears"
]